import { setSeed, getSeedFromUrl, DEFAULT_SEED } from './seed';
import { registry } from './registry';
import { generatePlants, generateLines, generateStations, generateMachines } from './plantGenerator';
import { generatePeople } from './peopleGenerator';
import { generateProducts } from './productGenerator';
import { generateWorkOrders } from './workOrderGenerator';
import { generateDefects } from './defectGenerator';
import { generateAlerts } from './alarmGenerator';
import { generateEvents } from './eventGenerator';
import { generateInventory } from './inventoryGenerator';
import { generateTelemetry } from './telemetryGenerator';

export { registry } from './registry';
export type { Registry } from './registry';
export * from './types';
export type { WorkOrderRow } from './workOrderGenerator';
export type { AlertRow } from './alarmGenerator';
export type { MESEventRow } from './eventGenerator';

export function initRegistry(seed?: number): void {
  const finalSeed = seed ?? getSeedFromUrl() ?? DEFAULT_SEED;
  setSeed(finalSeed);

  registry.plants = generatePlants();
  registry.lines = generateLines(registry.plants, 8);
  registry.stations = generateStations(registry.lines, 24);
  registry.machines = generateMachines(registry.stations, 35);
  registry.people = generatePeople(registry.plants, registry.stations, 45);
  registry.products = generateProducts(42);
  registry.workOrders = generateWorkOrders(registry.products, registry.stations, registry.people, 80);
  registry.defects = generateDefects(registry.workOrders, registry.stations, registry.people, 60);
  registry.alerts = generateAlerts(registry.machines, 30);
  registry.events = generateEvents(registry.workOrders, registry.people, 150);
  registry.inventory = generateInventory(registry.products, 200);
  registry.telemetry = generateTelemetry(registry.machines, 60);

  registry.initialized = true;
  registry.seed = finalSeed;

  // eslint-disable-next-line no-console
  console.log('[Registry] inicializado seed=' + finalSeed, {
    plants: registry.plants.length,
    lines: registry.lines.length,
    stations: registry.stations.length,
    machines: registry.machines.length,
    people: registry.people.length,
    products: registry.products.length,
    workOrders: registry.workOrders.length,
    defects: registry.defects.length,
    alerts: registry.alerts.length,
    events: registry.events.length,
    inventory: registry.inventory.length,
    telemetrySignals: Object.keys(registry.telemetry).length,
  });
}
